import { render, staticRenderFns } from "./closeZone.vue?vue&type=template&id=15394556&scoped=true"
import script from "./closeZone.vue?vue&type=script&lang=js"
export * from "./closeZone.vue?vue&type=script&lang=js"
import style0 from "./closeZone.vue?vue&type=style&index=0&id=15394556&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15394556",
  null
  
)

export default component.exports